import React, { Component } from 'react'
import { Trans } from 'react-i18next'
import './styles.css'

class ProLabel extends Component {
  render () {
    return (
      <span className="ProLabel"><Trans>PRO_LABEL</Trans></span>
    )
  }
}

export default ProLabel
